import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  Checkbox,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import { issueList, issueSolveapi } from "../../../Services/Services";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useEffect } from "react";
import IssueForm from "./IssueForm";
import Popover from "@mui/material/Popover";
import Tooltip from "@mui/material/Tooltip";



export default function IssueList() {
  const [issues, setIssues] = useState([]);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [issueSolve, setissueSolve] = useState(null);
  const [search, setSearch] = useState({
    freight_id: "",
    branch_id: "",
    vehicle_no: "",
  });
  useEffect(() => {
    const fetchIssue = async () => {
      const data = await issueList();
      setIssues(data);
    };

    fetchIssue();
  }, []);
  const [open, setOpen] = useState(false);
  const [currentIssue, setCurrentIssue] = useState(null);

  // const handleEdit = (issue) => {
  //   setCurrentIssue(issue);
  //   setOpen(true);
  // };

  const handleClose = () => {
    setOpen(false);
    setCurrentIssue(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentIssue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = () => {
    setIssues((prev) =>
      prev.map((item) => (item.id === currentIssue.id ? currentIssue : item))
    );
    handleClose();
  };

  const handleDelete = async (Id) => {
    try {
      const response = await issueSolveapi(Id); // don't pass any argument if not needed
      setIssues(response);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearch((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // const filteredIssues = issues.filter((issue) => {
  //   return (
  //     issue.freight_id
  //       .includes(search.freight_id.toLowerCase()) &&
  //     issue.branch_id.toLowerCase().includes(search.branch_id.toLowerCase()) &&
  //     issue.vehicle_no.toLowerCase().includes(search.vehicle_no.toLowerCase())
  //   );
  // });

  const filteredIssues = issues;
  // PDF Function
  const handlePrintHTML = () => {
    const originalTable = document.getElementById("issue-table");
    if (!originalTable) return;

    // Clone table to avoid mutating original DOM
    const clonedTable = originalTable.cloneNode(true);

    // Remove "no-print" and checkbox columns by index
    const removeIndexes = new Set();
    const headerRow = clonedTable.querySelector("thead tr");

    if (headerRow) {
      headerRow.querySelectorAll("th").forEach((th, idx) => {
        if (
          th.classList.contains("no-print") ||
          th.innerText.toLowerCase().includes("actions") ||
          th.querySelector("input[type='checkbox']")
        ) {
          removeIndexes.add(idx);
        }
      });
    }

    // Remove cells by index in all rows
    clonedTable.querySelectorAll("tr").forEach((row) => {
      const cells = Array.from(row.children);
      for (let i = cells.length - 1; i >= 0; i--) {
        const cell = cells[i];
        if (
          removeIndexes.has(i) ||
          cell.classList.contains("no-print") ||
          cell.querySelector("input[type='checkbox']")
        ) {
          cell.remove();
        }
      }
    });

    // Now get the cleaned table HTML
    const printContent = clonedTable.outerHTML;

    // Open print window
    const printWindow = window.open("", "", "width=1000,height=600");

    printWindow.document.write(`
    <html>
    <head>
      <style>
        body {
          font-family: Arial, sans-serif;
          padding: 0px 20px;
        }
        header {
          text-align: center;
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 20px;
          color: #333;
        }
        footer {
          position: fixed;
          bottom: 10px;
          width: 100%;
          text-align: center;
          font-size: 12px;
          color: #333;
        }
        table {
          width: 100%;
          border-collapse: collapse;
        }
        th, td {
          border: 1px solid black;
          padding: 8px;
          text-align: center;
          font-size: 12px;
          white-space: nowrap;
        }
        th {
          background-color: rgba(211, 211, 211, 0.42);
          color: #000;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        .no-print {
          display: none !important;
        }
        @media print {
          html, body {
            zoom: 90%;
          }
        }
      </style>
    </head>
    <body>
      <header>SR ENTERPRICES</header>
      <h3 style="text-align: center;">Issue List</h3>
      ${printContent}
      <footer>Powered by : YASHVITECH IT SOLUTION PVT LTD</footer>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();
  };


  const handleExportExcel = () => {
    const table = document.getElementById("issue-table");

    if (!table) {
      alert("Table not found!");
      return;
    }

    const rows = table.querySelectorAll("tr");
    if (!rows.length) {
      alert("No data to export");
      return;
    }

    const worksheetData = [];
    const removeIndexes = new Set();

    // Step 1: Identify columns to skip (based on "no-print" in header)
    const headerCells = rows[0].querySelectorAll("th, td");
    headerCells.forEach((cell, idx) => {
      if (cell.classList.contains("no-print") || cell.innerText.trim().toLowerCase() === "actions") {
        removeIndexes.add(idx);
      }
    });

    // Step 2: Extract data row by row
    rows.forEach((row) => {
      const cells = row.querySelectorAll("th, td");
      const rowData = [];

      cells.forEach((cell, idx) => {
        if (!removeIndexes.has(idx)) {
          rowData.push(cell.innerText.trim());
        }
      });

      if (rowData.length) {
        worksheetData.push(rowData);
      }
    });

    if (!worksheetData.length) {
      alert("No valid data found to export.");
      return;
    }

    const headers = worksheetData[0];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Auto-fit column widths
    const columnWidths = headers.map((_, colIndex) => {
      const maxLength = worksheetData.reduce((max, row) => {
        const cell = row[colIndex];
        const len = cell ? cell.toString().length : 10;
        return Math.max(max, len);
      }, headers[colIndex].length);
      return { wch: maxLength + 2 };
    });
    worksheet["!cols"] = columnWidths;

    const blackBorder = {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    };

    // Style headers
    headers.forEach((_, colIdx) => {
      const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: colIdx })];
      if (cell) {
        cell.s = {
          fill: { fgColor: { rgb: "FFFF99" } },
          font: { bold: true, color: { rgb: "000000" } },
          alignment: { horizontal: "center", vertical: "center" },
          border: blackBorder,
        };
      }
    });

    // Style data cells
    for (let r = 1; r < worksheetData.length; r++) {
      for (let c = 0; c < headers.length; c++) {
        const cell = worksheet[XLSX.utils.encode_cell({ r, c })];
        if (cell) {
          cell.s = {
            alignment: { horizontal: "center", vertical: "center" },
            border: blackBorder,
          };
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Branch Data");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "BranchList.xlsx");
  };

  return (
    <div style={{ width: "100%", maxHeight: "calc(100vh - 70px)" }}>
      {/* 🔍 Search Fields */}
      <Box
        sx={{
          mb: 2,
          display: "flex",
          gap: 2,
          py: 1,
          flexWrap: "wrap",
          position: "sticky",
          top: 10,
          zIndex: 1000,
        }}
      >
        <TextField
          label="Search by Freight ID"
          name="freight_id"
          value={search.freight_id}
          onChange={handleSearchChange}
          size="small"
          sx={{ width: 250, marginTop: -4 }}
        />
        <TextField
          label="Search by Branch ID"
          name="branch_id"
          value={search.branch_id}
          onChange={handleSearchChange}
          size="small"
          sx={{ width: 250, marginTop: -4 }}
        />
        <TextField
          label="Search by Vehicle No."
          name="vehicle_no"
          value={search.vehicle_no}
          onChange={handleSearchChange}
          size="small"
          sx={{ width: 250, marginTop: -4 }}
        />
        {/* Icon Buttons */}
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpenAddModal(true)}
          sx={{ width: 250, marginTop: -4 }}
        >
          Add New Issue
        </Button>
        <Button
          variant="outlined"
          onClick={handleExportExcel}
          sx={{ minWidth: "40px", height: "40px", padding: 0, marginTop: -4 }}
        >
          <FileDownloadIcon fontSize="small" />
        </Button>
        <Button
          variant="outlined"
          onClick={handlePrintHTML}
          sx={{ minWidth: "40px", height: "40px", padding: 0, marginTop: -4 }}
        >
          <PrintIcon fontSize="small" />
        </Button>
      </Box>

      {/* 📋 Table */}
      <TableContainer
        sx={{
          overflowX: "auto",
          width: "100%", // Fill parent width
          padding: 0, // Remove padding
          margin: 0, // Remove margin
        }}
      >
        <div
          style={{
            minWidth: "1000px", // Or however wide your table needs to be
            maxHeight: "75vh",
            overflowX: "auto",
            padding: 0,
            margin: 0,
          }}
        >
          <Table
            stickyHeader
            size="small"
            id="issue-table"
            sx={{
              tableLayout: "auto",
              whiteSpace: "nowrap",
              "& td, & th": {
                borderBottom: "1px solid #ccc",
                textAlign: "center",
                whiteSpace: "nowrap", // prevent wrapping
              },
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    borderBottom: "1px solid #999",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#2196f3" : "#333",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                    whiteSpace: "nowrap",
                  },
                }}
              >
                <TableCell align="center" className="no-print">
                  Actions
                </TableCell>
                <TableCell>SR. No</TableCell>
                <TableCell>ID</TableCell>
                <TableCell>Freight ID</TableCell>
                <TableCell>Branch Name</TableCell>
                <TableCell>Party Name</TableCell>
                <TableCell>Vehicle No</TableCell>
                <TableCell>Description</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredIssues.length > 0 ? (
                filteredIssues.map((issue, index) => (
                  <TableRow
                    key={issue.id}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                      "& td": {
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "white" : "inherit",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "black" : "inherit",
                        borderBottom: "1px solid #999",
                        paddingTop: "0px",
                        paddingBottom: "0px",
                        fontSize: "0.8125rem",
                        whiteSpace: "nowrap",
                      },
                    }}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        size="small"
                        onClick={(e) => {
                          setAnchorEl(e.currentTarget);
                          setissueSolve(issue.issue_id);
                        }}
                      />
                    </TableCell>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{issue.issue_id}</TableCell>
                    <TableCell>{issue.freight_id}</TableCell>
                    <TableCell>{issue.branch_name}</TableCell>
                    <TableCell>{issue.party_name}</TableCell>
                    <TableCell>{issue.truck_no}</TableCell>


                    {/* <TableCell
                      sx={{
                        maxWidth: 200,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {issue.description}
                    </TableCell> */}




                    <TableCell
                      sx={{
                        maxWidth: 200,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Tooltip
                        arrow
                        placement="top"
                        title={issue.description || "No description"}
                      >
                        <span
                          style={{
                            display: "inline-block",
                            maxWidth: "200px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "pointer",
                          }}
                        >
                          {issue.description}
                        </span>
                      </Tooltip>
                    </TableCell>









                    {/* <TableCell className="no-print">
                      <Stack direction="row" spacing={1} justifyContent="center">
                        <IconButton
                          color="error"
                          onClick={() => handleDelete(issue.id)}
                          size="small"
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Stack>
                    </TableCell> */}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    <Typography variant="body2" color="text.secondary">
                      No matching records found.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </TableContainer>

      {/* ✏️ Edit Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        scroll="body"
        PaperProps={{
          sx: {
            width: { xs: "95%", sm: "600px" },
            m: 1,
          },
        }}
      >
        <DialogTitle>Edit Issue</DialogTitle>

        <DialogContent dividers sx={{ px: { xs: 2, sm: 3 }, pt: 2 }}>
          <Stack spacing={2}>
            <TextField
              label="Freight ID"
              name="freight_id"
              fullWidth
              value={currentIssue?.freight_id || ""}
              onChange={handleChange}
            />
            <TextField
              label="Branch ID"
              name="branch_id"
              fullWidth
              value={currentIssue?.branch_id || ""}
              onChange={handleChange}
            />
            <TextField
              label="Vehicle No"
              name="vehicle_no"
              fullWidth
              value={currentIssue?.vehicle_no || ""}
              onChange={handleChange}
            />
            <TextField
              label="Description"
              name="description"
              fullWidth
              multiline
              rows={3}
              value={currentIssue?.description || ""}
              onChange={handleChange}
            />
          </Stack>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openAddModal}
        onClose={() => setOpenAddModal(false)}
        // maxWidth="sm"

        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Add New Issue</DialogTitle>
        <DialogContent dividers>
          <IssueForm setIssues={setIssues} setOpenAddModal={setOpenAddModal} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAddModal(false)} color="error">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setissueSolve(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box sx={{ p: 1 }}>
          <Typography variant="body2">Are you sure?</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                try {
                  await handleDelete(issueSolve);
                } finally {
                  setAnchorEl(null);
                  setissueSolve(null);
                }
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setissueSolve(null);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Popover>
    </div>
  );
}


